import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UserAccountContainer } from '@components/organisms/UserAccountContainer';
import { SpaceForm } from '@components/molecules/SpaceForm';

export const AdminSpacesCreate: FC = () => {
    const { t } = useTranslation();

    return (
        <UserAccountContainer title={t('user-account-sidebar.create-space')}>
            <div className="mt-3">
                <SpaceForm edit={false} />
            </div>
        </UserAccountContainer>
    );
};